import { render } from "./details.vue?vue&type=template&id=329ab2e8&scoped=true"
import script from "./details.vue?vue&type=script&lang=js"
export * from "./details.vue?vue&type=script&lang=js"

import "./details.vue?vue&type=style&index=0&id=329ab2e8&scoped=true&lang=scss"

import exportComponent from "/root/workspace/interactive-system-pc_dBxe/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-329ab2e8"]])

export default __exports__